import { reactive, computed } from "vue";

export function useQueue<T>() {
  const queue = reactive([]) as T[];
  const isEmpty = computed(() => queue.length === 0);

  function enqueue(data: T) {
    queue.push(data as T);
  }

  function dequeue(): T | undefined {
    return queue.shift();
  }

  function peek(): T | undefined {
    return queue.at(0);
  }

  function iterate(callback: (data: T) => void) {
    while (queue.length > 0) {
      const item = dequeue();
      if (item) {
        callback(item);
      }
    }
  }

  function clear() {
    queue.length = 0;
  }

  return {
    isEmpty,
    enqueue,
    dequeue,
    peek,
    iterate,
    clear,
  };
}
